import React, {
  useState,
} from 'react';
import Button from 'pages/Dashboard/components/Button';
import ToolTip from 'core/components/Tooltip';
import {
  MobileIcon,
} from 'core/icons';
import OneTimeAnchoredHint from 'core/components/OneTimeAnchoredHint';
import useStorageState from 'core/hooks/storage';
import SnapMobileAppDialog from 'views/EMR/components/Snap/SnapMobileAppDialog';

const SNAP_MOBILE_APP_HINT_KEY = 'browser:visit-note-snap-mobile-app-hint';

export default function SnapMobileAppIndicator() {
  const [
    showSnapMobileApp,
    setShowSnapMobileApp,
  ] = useState(false);
  const [
    buttonElement,
    setButtonElement,
  ] = useState<HTMLElement | null>(null);
  const [
    hintDismissed,
    setHintDismissed,
  ] = useStorageState<boolean>(SNAP_MOBILE_APP_HINT_KEY, false, 'local');

  return (
    <>
      <span aria-hidden className="self-center w-px h-3.5 bg-slate-200" />
      <ToolTip title="Download the iPhone app">
        <Button
          ref={setButtonElement}
          className="!px-1.5 !h-full !border-0 !rounded-none hover:!bg-gray-50"
          variant="outlined"
          aria-label="Download the SNAP iPhone app"
          onClick={() => {
            setHintDismissed(true);
            setShowSnapMobileApp(true);
          }}
        >
          <MobileIcon className="!w-4 !h-4" />
        </Button>
      </ToolTip>
      <OneTimeAnchoredHint
        storageKey={SNAP_MOBILE_APP_HINT_KEY}
        anchorEl={buttonElement}
        show={!hintDismissed}
        placement="bottom-start"
      >
        Record visits from your iPhone with the new SNAP app
      </OneTimeAnchoredHint>
      {showSnapMobileApp && (
        <SnapMobileAppDialog
          onClose={() => { setShowSnapMobileApp(false); }}
        />
      )}
    </>
  );
}
